isInlineFragment